import { render, staticRenderFns } from "./agravosView.vue?vue&type=template&id=1a1d82d4"
import script from "./agravosView.vue?vue&type=script&lang=js"
export * from "./agravosView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports